var address = require('./address_proto');
var address_fields_list = address.getFieldsList();

var Address = function (data, type) {
    this.type = type ? type : Math.floor(Math.random()*1000);

    address_fields_list.forEach(function (field) {
        this[field.name] = ko.observable(data && data[field.name] || field.def_value || '');
    }, this);
};
Address.prototype = address;

module.exports = Address;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/components/Address.js
// module id = 29
// module chunks = 0